import axios from 'axios'
import { ElMessage } from 'element-plus'
import { useRouter, useRoute } from 'vue-router'
import router from '@/router'
const instance = axios.create({
    baseURL: 'https://human.alight-sys.com',
    timeout: 15000,
  })
  const CONTENT_TYPE = {
    JSON: 'application/json;charset=UTF-8',
    FORM: 'application/x-www-form-urlencoded; charset=UTF-8',
    FILE: 'multipart/form-data;charset=UTF-8',
  }
  instance.interceptors.request.use(
    function (config) {
      if (config.method.toUpperCase() === 'POST' && config.contentType === 'FORM') {
        config.data = qs.stringify(config.data)
        config.headers['content-type'] = CONTENT_TYPE.FORM
      } else if (config.contentType === 'FILE') {
        config.headers['content-type'] = CONTENT_TYPE.FILE
      } else {
        config.headers['content-type'] = CONTENT_TYPE.JSON
      }
    return config
    },
    function (error) {
      return Promise.reject(error)
    }
  )
  instance.interceptors.response.use(
    function (response) {
      if (response.data.code === 401) {
        ElMessage.error('登录失效,请重新登录')
        localStorage.removeItem('userId')
        sessionStorage.removeItem('activeIndex')
        router.replace('/login')
      }
    return response.data
    },
    function (error) {
      console.log(error,'response error')
      return Promise.reject(error)
    }
  )
  export default instance